<!-- Vehicle Repair Management -->
<div class="d-flex flex-column flex-column-fluid">
  <!-- Card -->
  <div class="card">
    <!-- Card Header -->
    <div class="card-header border-0 pt-6">
      <div class="card-title">
        <!-- Search -->
        <div class="d-flex align-items-center position-relative my-1">
          <i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          <input type="text" [(ngModel)]="searchTerm" (keyup.enter)="onSearch()"
            class="form-control form-control-solid w-250px ps-13" placeholder="Search vehicle repairs..." />
        </div>
      </div>

      <!-- Card Toolbar -->
      <div class="card-toolbar">
        <!-- Filter Toggle -->
        <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
          <button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3" (click)="showFiltersForm = !showFiltersForm">
            <i class="ki-duotone ki-magnifier fs-6 text-muted me-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            Search
          </button>

          <!-- Add Vehicle Repair -->
          <button type="button" class="btn btn-sm btn-primary fw-bold d-flex" (click)="openAddVehicleRepairModal()">
            <i class="ki-duotone ki-plus fs-2"></i>
            Add Vehicle Repair
          </button>
        </div>
      </div>
    </div>

    <!-- Filters Form -->
    <div class="card-body py-4" *ngIf="showFiltersForm">
      <div class="row g-4">
        <!-- Search Keyword -->
        <div class="col-md-3">
          <label class="form-label">Search Keyword</label>
          <input type="text" class="form-control form-control-solid"
            placeholder="Enter keyword..."
            [(ngModel)]="filters.search" />
        </div>

        <!-- Stock Number -->
        <div class="col-md-3">
          <label class="form-label">Stock Number</label>
          <input type="text" class="form-control form-control-solid"
            placeholder="Enter stock number..."
            [(ngModel)]="filters.stock_number" />
        </div>

        <!-- Order Date From -->
        <div class="col-md-3">
          <label class="form-label">Order Date From</label>
          <input type="date" class="form-control form-control-solid"
            [(ngModel)]="filters.order_date_from" />
        </div>

        <!-- Order Date To -->
        <div class="col-md-3">
          <label class="form-label">Order Date To</label>
          <input type="date" class="form-control form-control-solid"
            [(ngModel)]="filters.order_date_to" />
        </div>

        <!-- Complete Date From -->
        <div class="col-md-3">
          <label class="form-label">Complete Date From</label>
          <input type="date" class="form-control form-control-solid"
            [(ngModel)]="filters.complete_date_from" />
        </div>

        <!-- Complete Date To -->
        <div class="col-md-3">
          <label class="form-label">Complete Date To</label>
          <input type="date" class="form-control form-control-solid"
            [(ngModel)]="filters.complete_date_to" />
        </div>

        <!-- Status -->
        <div class="col-md-3">
          <label class="form-label">Status</label>
          <select class="form-select form-select-solid" [(ngModel)]="filters.status">
            <option value="">All</option>
            <option value="Pending">Pending</option>
            <option value="Repaired">Repaired</option>
          </select>
        </div>

        <!-- Filter Actions -->
        <div class="col-md-3 d-flex align-items-end">
          <button type="button" class="btn btn-primary me-2" (click)="applyFilters()">Apply</button>
          <button type="button" class="btn btn-secondary" (click)="clearFilters()">Clear</button>
        </div>
      </div>
    </div>

    <!-- Card Body -->
    <div class="card-body py-4">
      <!-- Vehicle Repairs Table -->
      <div class="table-responsive">
        <table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
          <thead>
            <tr class="fw-bold text-muted bg-light">
              <th class="min-w-150px">Repair Id</th>
              <th class="min-w-150px">Stock</th>
              <th class="min-w-150px">Company</th>
              <th class="min-w-100px">Cost</th>
              <th class="min-w-120px">Order Date</th>
              <th class="min-w-120px">Complete Date</th>
              <th class="min-w-100px">Status</th>
              <th class="min-w-200px">Problems</th>
              <th class="min-w-200px">Note</th>
              <th class="min-w-100px text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <!-- Loading State -->
            <tr *ngIf="isLoading">
              <td colspan="9" class="text-center py-5">
                <div class="d-flex justify-content-center align-items-center">
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Loading vehicle repairs...
                </div>
              </td>
            </tr>

            <!-- No Data State -->
            <tr *ngIf="!isLoading && vehicleRepairs.length === 0">
              <td colspan="9" class="text-center py-5 text-muted">
                No vehicle repairs found
              </td>
            </tr>

            <!-- Data Rows -->
            <tr *ngFor="let repair of vehicleRepairs; trackBy: trackByFn">
              <td>
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ repair.repair_id || '-' }}
                </span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <div class="symbol symbol-45px me-5">
                    <img [src]="getVehicleImageUrl(repair.vehicle)" alt="Vehicle" />
                  </div>
                  <div class="d-flex justify-content-start flex-column">
                    <span class="text-dark fw-bold text-hover-primary fs-6">
                      {{ repair.vehicle?.car_no || repair.stock || '-' }}
                    </span>
                    <span class="text-muted fw-semibold text-muted d-block fs-7">
                      {{ repair.vehicle?.vin_no || repair.vehicle?.chassis_no || '-' }}
                    </span>
                  </div>
                </div>
              </td>
              <td>
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ repair.company || '-' }}
                </span>
              </td>
              <td>
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ repair.cost ? (repair.cost + ' JPY') : '-' }}
                </span>
              </td>
              <td>
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ formatDate(repair.order_date) }}
                </span>
              </td>
              <td>
                <span class="text-dark fw-semibold d-block fs-7">
                  {{ formatDate(repair.complete_date) }}
                </span>
              </td>
              <td>
                <span class="badge fs-7 fw-bold" [ngClass]="getStatusBadgeClass(repair.status)">
                  {{ repair.status || 'Pending' }}
                </span>
              </td>
              <td>
                <span class="text-dark fw-semibold d-block fs-7" [title]="repair.problems">
                  {{ (repair.problems || '-') | slice:0:50 }}{{ repair.problems && repair.problems.length > 50 ? '...' :
                  '' }}
                </span>
              </td>
              <td>
                <span class="text-dark fw-semibold d-block fs-7" [title]="repair.note">
                  {{ (repair.note || '-') | slice:0:50 }}{{ repair.note && repair.note.length > 50 ? '...' : '' }}
                </span>
              </td>

              <td class="text-end">
                <div class="d-flex justify-content-end gap-2">


                  <!-- Edit Icon -->
                  <button type="button" class="btn btn-sm btn-icon btn-light-primary"
                    (click)="openEditVehicleRepairModal(repair)" title="Edit Export Certificate">
                    <i class="ki-duotone ki-pencil fs-5">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </button>

                  <!-- Delete Icon -->
                  <button type="button" class="btn btn-sm btn-icon btn-light-danger"
                    (click)="deleteVehicleRepair(repair)" title="Delete Transport Pickup">
                    <i class="ki-duotone ki-trash fs-5">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <app-pagination *ngIf="!isLoading && vehicleRepairs.length > 0" [paginationInfo]="paginationInfo"
        [loading]="isLoading" (pageChange)="onPageChange($event)">
      </app-pagination>
    </div>
  </div>
</div>

<!-- Add/Edit Vehicle Repair Modal -->
<app-add-edit-vehicle-repair (vehicleRepairAdded)="onVehicleRepairAdded()"
  (vehicleRepairUpdated)="onVehicleRepairUpdated()">
</app-add-edit-vehicle-repair>
